import React, { memo, useState } from 'react';
import { TouchableOpacity, StyleSheet, ActivityIndicator, View } from 'react-native';
import { Text } from '../../../components/ui/AppText';
import { LinearGradient } from 'expo-linear-gradient';
import * as Haptics from 'expo-haptics';

/**
 * ChallengeButton com 4 estados:
 * - enabled: Roxo, pronto para desafiar
 * - pending: Laranja, já tem desafio pendente
 * - disabled: Cinza, limite atingido
 * - loading: Indicador de carregamento
 */
const ChallengeButton = memo(({
    state = 'enabled', // 'enabled' | 'pending' | 'disabled' | 'loading'
    onPress,
    remainingChallenges = 4,
}) => {
    const handlePress = () => {
        if (state === 'loading') return;

        if (state === 'pending' || state === 'disabled') {
            Haptics.notificationAsync(Haptics.NotificationFeedbackType.Warning);
        } else {
            Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Medium);
        }
        onPress?.();
    };

    const renderContent = () => {
        switch (state) {
            case 'loading':
                return <ActivityIndicator size="small" color="#FFFFFF" />;
            case 'pending':
                return (
                    <>
                        <Text style={styles.pendingIcon}>⏳</Text>
                        <Text style={styles.pendingText}>Pendente</Text>
                    </>
                );
            case 'disabled':
                return (
                    <>
                        <Text style={styles.disabledIcon}>🚫</Text>
                        <Text style={styles.disabledText}>Limite</Text>
                    </>
                );
            default:
                return (
                    <>
                        <Text style={styles.enabledIcon}>⚔️</Text>
                        <Text style={styles.enabledText}>Desafiar</Text>
                    </>
                );
        }
    };

    if (state === 'enabled') {
        return (
            <TouchableOpacity onPress={handlePress} style={styles.container} activeOpacity={0.8}>
                <LinearGradient
                    colors={['#9333EA', '#7C3AED']}
                    style={styles.gradientButton}
                    start={{ x: 0, y: 0 }}
                    end={{ x: 1, y: 0 }}
                >
                    {renderContent()}
                </LinearGradient>
            </TouchableOpacity>
        );
    }

    return (
        <TouchableOpacity
            onPress={handlePress}
            style={[
                styles.container,
                styles.stateButton,
                state === 'pending' && styles.pendingButton,
                state === 'disabled' && styles.disabledButton,
            ]}
            activeOpacity={0.7}
        >
            {renderContent()}
        </TouchableOpacity>
    );
});

const styles = StyleSheet.create({
    container: {
        flex: 1,
        borderRadius: 12,
        overflow: 'hidden',
    },

    gradientButton: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 12,
        gap: 6,
    },

    stateButton: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 12,
        gap: 6,
    },

    pendingButton: {
        backgroundColor: 'rgba(255, 149, 0, 0.15)',
        borderWidth: 1,
        borderColor: 'rgba(255, 149, 0, 0.3)',
    },

    disabledButton: {
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        borderWidth: 1,
        borderColor: 'rgba(255, 255, 255, 0.08)',
    },

    enabledIcon: { fontSize: 14 },
    enabledText: { fontSize: 13, fontWeight: '700', color: '#FFFFFF' },

    pendingIcon: { fontSize: 14 },
    pendingText: { fontSize: 13, fontWeight: '600', color: '#FF9500' },

    disabledIcon: { fontSize: 14 },
    disabledText: { fontSize: 13, fontWeight: '600', color: 'rgba(255, 255, 255, 0.3)' },
});

export default ChallengeButton;
